import { Menu } from 'lucide-react'
import type { ReactNode } from 'react'
import { LogoMark } from '@/components/logo'
import { Button } from '@/components/ui/button'
import { useAuthedMe } from '@/features/auth/api'
import { NotificationBell } from '@/features/notifications/components/notification-bell'
import { useUiStore } from '@/stores/ui'
import { CommandPaletteButton } from './command-palette'
import { ThemeToggle } from './theme-toggle'
import { UserMenu } from './user-menu'

export function Topbar({ left }: { left?: ReactNode }) {
  const setMobileNavOpen = useUiStore((s) => s.setMobileNavOpen)
  // Notifications belong to an organization; a platform admin without one has none to poll.
  const hasTenant = useAuthedMe().current_tenant !== null
  return (
    <header className="sticky top-0 z-20 flex h-14 shrink-0 items-center gap-2 border-b bg-background/80 px-3 backdrop-blur-xl supports-[backdrop-filter]:bg-background/70 sm:px-4 lg:px-6">
      <Button variant="ghost" size="icon" className="lg:hidden" onClick={() => setMobileNavOpen(true)} aria-label="Open navigation">
        <Menu />
      </Button>
      <LogoMark className="size-7 lg:hidden" />
      <div className="min-w-0 flex-1">{left}</div>
      <div className="flex items-center gap-1 sm:gap-1.5">
        <CommandPaletteButton />
        {hasTenant && <NotificationBell />}
        <ThemeToggle />
        <UserMenu />
      </div>
    </header>
  )
}
